<div class="row__item__wrapper {{justify}}">
  <ng-content></ng-content>
</div>
